// The API lives on the same origin as the site (Cloudflare Pages Functions),
// so requests are simply relative to "/api" — no CORS, no backend URL to configure.
export const API = "/api";

export function getToken() {
  return localStorage.getItem("ci_token");
}

// fetch() wrapper that attaches the admin bearer token and returns parsed JSON.
// Throws an Error whose .status / .detail carry the server response.
export async function authFetch(path, { method = "GET", body, headers = {}, raw } = {}) {
  const token = getToken();
  const opts = { method, headers: { ...headers } };
  if (token) opts.headers.Authorization = `Bearer ${token}`;

  if (raw) {
    opts.body = raw; // e.g. FormData — let the browser set content-type
  } else if (body !== undefined) {
    opts.headers["content-type"] = "application/json";
    opts.body = JSON.stringify(body);
  }

  const res = await fetch(`${API}${path}`, opts);
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* no JSON body */
  }
  if (!res.ok) {
    const err = new Error((data && data.detail) || "Errore di rete");
    err.status = res.status;
    err.detail = data && data.detail;
    throw err;
  }
  return data;
}
